import { makeStyles } from '@material-ui/core/styles';
import { StandardDivProps } from '@sprinx/react-mui-components/StandardDiv';
import withThemeProps from '@sprinx/react-mui-components/withThemeProps';
import clsx from 'clsx';
import React from 'react';
import { useRecoilValue } from 'recoil';
import { catalogueViewModeState } from '../../../api/products/catalogue';
import CataloguePageListContentItemCardSkeleton from './CataloguePageListContentItemCardSkeleton';
import CataloguePageListContentItemRowSkeleton from './CataloguePageListContentItemRowSkeleton';

export type CataloguePageListContentSkeletonProps = StandardDivProps<CataloguePageListContentSkeletonClassKey>;

export type CataloguePageListContentSkeletonClassKey = 'root' | 'card';

const themeSettings = { name: 'CataloguePageListContentSkeleton' };
const useStyles = makeStyles(
  (/* theme */) => ({
    root: {},
    card: {
      display: 'flex',
      flexWrap: 'wrap',
    },
  }),
  themeSettings,
);

const CataloguePageListContentSkeleton = React.forwardRef<HTMLDivElement, CataloguePageListContentSkeletonProps>(
  ({ className, classes: pClasses }, ref) => {
    const classes = useStyles({ classes: pClasses });

    const catalogueView = useRecoilValue(catalogueViewModeState);

    return (
      <div ref={ref} className={clsx(classes.root, className)}>
        {catalogueView === 'row' && (
          <>
            <CataloguePageListContentItemRowSkeleton />
            <CataloguePageListContentItemRowSkeleton />
            <CataloguePageListContentItemRowSkeleton />
          </>
        )}
        {catalogueView === 'card' && (
          <div className={classes.card}>
            <CataloguePageListContentItemCardSkeleton />
            <CataloguePageListContentItemCardSkeleton />
            <CataloguePageListContentItemCardSkeleton />
            <CataloguePageListContentItemCardSkeleton />
            <CataloguePageListContentItemCardSkeleton />
            <CataloguePageListContentItemCardSkeleton />
          </div>
        )}
      </div>
    );
  },
);

CataloguePageListContentSkeleton.displayName = 'CataloguePageListContentSkeleton';

export default withThemeProps(themeSettings)(CataloguePageListContentSkeleton);
